import { forwardRef } from "react";
import { ValidatedTextInput } from "../inputs";
import { jsx } from "react/jsx-runtime";
const EmailInput = forwardRef(
  ({
    analyticsName,
    fieldRequiredError = "This field is required.",
    invalidEmailError = "Please enter a valid email address.",
    disableSuggestions = !1,
    title = "Email",
    size = "medium",
    required = !0,
    ariaLabelledBy,
    ...props
  }, ref) => /* @__PURE__ */ jsx(
    ValidatedTextInput,
    {
      ref,
      id: "email-login-input",
      analyticsName: `${analyticsName}-email`,
      format: "emailAddress",
      size,
      required,
      allowSuggestions: !disableSuggestions,
      customErrorMessages: {
        fieldRequired: fieldRequiredError,
        invalidEmail: invalidEmailError
      },
      ...ariaLabelledBy ? { ariaLabelledBy } : { title },
      ...props
    }
  )
);
EmailInput.displayName = "EmailInput";
export {
  EmailInput
};
